import React, { useContext } from 'react'
import { View } from 'oio-react'
import { LAYOUT_BOX } from 'config/constants/ui'
import InitiativeMoreButton from 'src/sites/kits/Initiative/components/MoreButton'
import ObjectCoverImage from 'src/sites/kits/Object/components/CoverImage'
import ObjectJoinButton from 'src/sites/kits/Object/components/JoinButton'
import ObjectTypeLabel from 'src/sites/kits/Object/components/TypeLabel'
import { Subtitle, Title } from 'src/sites/kits/UI'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'
import EventDateThumbnail from './DateThumbnail'

const ObjectViewEventHeader = () => {
   const { theme } = useGlobalState()
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX
   const { initiative } = useContext(InitiativeHierarchyContext)
   const coverImageUrl = initiative.coverMedia?.file.thumbnailUrlW1600
   const contentPaddingLeft = isBoxGL ? '60px[e-f]' : '40px[d] 60px[e-f]'

   return (
      <View
         display="flex"
         width="100%"
         flexFlow={isBoxGL ? 'column[a-d] row[e-f]' : 'column[a-c] row[d-f]'}>
         <View
            flex="0 0 auto"
            width={isBoxGL ? '100%[a-d] 470px[e-f]' : '100%[a-c] 470px[d-f]'}
            paddingTop="40px[a-c] 20px[d-f]"
            paddingBottom="40px[a-c]"
            paddingRight={coverImageUrl && contentPaddingLeft}>
            <View marginBottom="5px">
               <ObjectTypeLabel />
            </View>
            <View marginBottom={initiative.subtitle ? '10px' : '40px'}>
               <Title size="xl" color={theme.tmpContentTitleColor}>
                  {initiative.name}
               </Title>
            </View>
            {initiative.subtitle && (
               <View marginBottom="40px">
                  <Subtitle>
                     {initiative.subtitle}
                  </Subtitle>
               </View>
            )}
            <View display="flex" alignItems="center" width="100%[a]">
               <View
                  flex={coverImageUrl
                     ? '0 0 auto[a-d] 1 1 auto[e-f]'
                     : '0 0 auto'
                  }>
                  <ObjectJoinButton
                     buttonRounded
                     buttonSize="lg"
                     buttonWidth={coverImageUrl ? '100%[e-f]' : 'auto'}
                     popoverAnchorOriginVertical="bottom"
                  />
               </View>
               {initiative.currentUserCanEdit && (
                  <View flex="0 0 auto" marginLeft="3px">
                     <InitiativeMoreButton
                        buttonSize="lg"
                        buttonWidth="30px"
                        popoverAnchorOriginVertical="top"
                     />
                  </View>
               )}
            </View>
         </View>
         {coverImageUrl && (
            <View position="relative" width="100%">
               <ObjectCoverImage
                  aspectRatio={0.6}
                  borderRadius="8px"
               />
               <View position="absolute" top="20px" left="20px">
                  <EventDateThumbnail />
               </View>
            </View>
         )}
      </View>
   )
}

export default ObjectViewEventHeader
